module.exports = __webpack_public_path__ + "assets/exitfullscreen.e8ea20dc.svg";